function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "star");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-page-/-Student",
  transform: "translate(-520.000000, -463.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(48.000000, 266.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6-Copy",
  transform: "translate(339.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(19.937695, 190.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "star",
  transform: "translate(114.567901, 7.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.87575177,11.5111084 C2.73498345,11.5111084 2.59519539,11.4700928 2.47589523,11.3895264 C2.25366559,11.2391052 2.14985384,10.9805603 2.21033716,10.7310791 L3.03690994,7.33053588 L0.233698944,5.03457642 C0.0276439062,4.86657715 -0.0510726237,4.60052489 0.0335256161,4.35708619 C0.118123831,4.11410522 0.348293764,3.94207762 0.620811828,3.91854858 L4.32980229,3.60406495 L5.79620435,0.399078375 C5.90432933,0.163604742 6.15057587,0.0115356562 6.42417225,0.0115356562 C6.6977686,0.0115356562 6.94401514,0.163604742 7.05214012,0.398529047 L8.51854219,3.60406495 L12.2269445,3.91854858 C12.5000507,3.94152832 12.7302206,4.11410522 12.8148189,4.35708619 C12.8994171,4.60006713 12.8211907,4.86657715 12.6151357,5.03457642 L9.81192467,7.33007812 L10.6384974,10.7305298 C10.6990788,10.9805603 10.595169,11.2391052 10.3730374,11.3890686 C10.1513959,11.539032 9.85584125,11.5505676 9.6224364,11.4195557 L6.42417225,9.63455201 L3.22590808,11.4205627 C3.1177831,11.4805298 2.99730659,11.5111084 2.87575177,11.5111084 Z M6.42417225,8.86560059 C6.54572707,8.86560059 6.66610553,8.89608764 6.77432853,8.95605469 L9.79271117,10.6420898 L9.01260371,7.43252564 C8.95692376,7.20410156 9.03995353,6.9656067 9.22895167,6.81106568 L11.8758079,4.64309693 L8.37395076,4.34609986 C8.12182254,4.32458496 7.90498442,4.1765442 7.80646621,3.9595642 L6.42417225,0.93502807 L5.04021179,3.96002198 C4.9427719,4.17553711 4.72593376,4.32357787 4.47439371,4.34509277 L0.972046448,4.64208984 L3.61880463,6.81005859 C3.80839092,6.96505737 3.89132269,7.20309448 3.83515261,7.43206786 L3.05563331,10.6415405 L6.07401592,8.95605469 C6.1821409,8.89608764 6.30261743,8.86560059 6.42417225,8.86560059 Z",
  id: "Shape"
})))))));

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.e5258138.svg";
export { ForwardRef as ReactComponent };